import React, { useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import { FiEdit2, FiPlus, FiFilter, FiRotateCcw } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import { homeScreenData } from "./useHook";
import Swal from "sweetalert2";
import { usePermission, SystemPermissions } from "../../Utils/permissionAccess";
import HomeScreenEntryModal from "../../Containers/general/home-screen/component/HomeScreenEntryModal";

function DataManagement() {
  const {
    getHomeScreenData,
    postHomeScreenData,
    updateHomeScreenData,
    deleteHomeScreenData,
    getHomeScreenTypes,
    getHomeScreenSubTypes,
  } = homeScreenData();

  const location = useLocation();
  const { value: originalValue } = location.state || {};

  const valueMapping = {
    ourProjects: "projects",
    estimations: "construction",
  };

  const value = valueMapping[originalValue] || originalValue;

  const { hasPermission } = usePermission();

  const permissionMap = {
    houseDesign: {
      create: SystemPermissions.HomeScreenHouseDesign.CREATE,
      update: SystemPermissions.HomeScreenHouseDesign.CREATE,
      delete: SystemPermissions.HomeScreenHouseDesign.DELETE,
    },
    frontElevation: {
      create: SystemPermissions.HomeScreenHouseDesign.CREATE,
      update: SystemPermissions.HomeScreenHouseDesign.CREATE,
      delete: SystemPermissions.HomeScreenHouseDesign.DELETE,
    },
    projects: {
      create: SystemPermissions.HomeScreenConsturctionOurProjects.CREATE,
      update: SystemPermissions.HomeScreenConsturctionOurProjects.CREATE,
      delete: SystemPermissions.HomeScreenConsturctionOurProjects.DELETE,
    },
    blog: {
      create: SystemPermissions.HomeScreenConsturctionBlogs.CREATE,
      update: SystemPermissions.HomeScreenConsturctionBlogs.CREATE,
      delete: SystemPermissions.HomeScreenConsturctionBlogs.DELETE,
    },
    interiorDesign: {
      create: SystemPermissions.HomeScreenInteriorDesign.CREATE,
      update: SystemPermissions.HomeScreenInteriorDesign.CREATE,
      delete: SystemPermissions.HomeScreenInteriorDesign.DELETE,
    },
    shop: {
      create: SystemPermissions.HomeScreenConsturctionShop.CREATE,
      update: SystemPermissions.HomeScreenConsturctionShop.CREATE,
      delete: SystemPermissions.HomeScreenConsturctionShop.DELETE,
    },
    construction: {
      create: SystemPermissions.HomeScreenConsturctionCalculaotr.CREATE,
      update: SystemPermissions.HomeScreenConsturctionCalculaotr.CREATE,
      delete: SystemPermissions.HomeScreenConsturctionCalculaotr.DELETE,
    },
  };

  const categoryPermissions = permissionMap[value] || {};
  const canCreate = categoryPermissions.create
    ? hasPermission(categoryPermissions.create)
    : true;
  const canUpdate = categoryPermissions.update
    ? hasPermission(categoryPermissions.update)
    : canCreate;
  const canDelete = categoryPermissions.delete
    ? hasPermission(categoryPermissions.delete)
    : true;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [homeScreen, setHomeScreen] = useState([]);
  const [types, setTypes] = useState([]);
  const [filterTypeId, setFilterTypeId] = useState("");
  const [appliedFilterTypeId, setAppliedFilterTypeId] = useState("");

  useEffect(() => {
    getHomeScreenData(setHomeScreen);
    const fetchTypes = async () => {
      const t = await getHomeScreenTypes();
      setTypes(t);
    };
    fetchTypes();
  }, []);

  const openAddModal = () => {
    setEditingItem(null);
    setIsModalOpen(true);
  };

  const openEditModal = (item) => {
    setEditingItem(item);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setEditingItem(null);
  };

  const handleSave = async (payload) => {
    try {
      if (editingItem) {
        const response = await updateHomeScreenData(editingItem.id, payload);
        if (response && response.success === false) {
          throw new Error(response.message || "Failed to update item.");
        }
        Swal.fire(
          "Success!",
          response?.message || "Item updated successfully.",
          "success",
        );
      } else {
        const response = await postHomeScreenData(payload);
        if (response && response.success === false) {
          throw new Error(response.message || "Failed to add item.");
        }
        Swal.fire(
          "Success!",
          response?.message || "Item added successfully.",
          "success",
        );
      }

      await getHomeScreenData(setHomeScreen);
      closeModal();
    } catch (error) {
      console.error(error);
      Swal.fire(
        "Error!",
        error?.message || "Something went wrong.",
        "error",
      );
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await deleteHomeScreenData(id);
        if (response && response.success === false) {
          throw new Error(response.message || "Failed to delete item.");
        }
        await getHomeScreenData(setHomeScreen);
        Swal.fire(
          "Deleted!",
          response?.message || "Your item has been deleted.",
          "success",
        );
      } catch (error) {
        console.error(error);
        Swal.fire(
          "Error!",
          error?.message || "Something went wrong.",
          "error",
        );
      }
    }
  };

  let categoryData = [];
  if (Array.isArray(homeScreen)) {
    categoryData = homeScreen;
  } else if (Array.isArray(homeScreen?.data)) {
    categoryData = homeScreen.data;
  }

  if (appliedFilterTypeId && appliedFilterTypeId !== "all") {
    categoryData = categoryData.filter(
      (item) => item.type?.id?.toString() === appliedFilterTypeId,
    );
  }

  return (
    <div>
      <div className="flex flex-wrap gap-4 justify-between items-center">
        <h2 className="text-2xl font-bold">Home Screen Management</h2>

        {canCreate && (
          <button onClick={openAddModal} className="btn btn-primary h-[44px]">
            <FiPlus className="text-white" />
            Add New Entry
          </button>
        )}
      </div>

      <div className="bg-white p-5 w-full rounded-lg pagination-shadow flex flex-wrap xlCustom:flex-nowrap xlCustom:justify-end items-center gap-3 my-5">
        <select
          className="status-select"
          value={filterTypeId}
          onChange={(e) => setFilterTypeId(e.target.value)}
        >
          <option value="" className="opacity-25">Select Type</option>
          {types.map((t) => (
            <option key={t.id} value={t.id.toString()}>
              {t.name}
            </option>
          ))}
        </select>
        <div className="flex flex-wrap md:flex-nowrap gap-2">
          <button className="btn btn-filter filter-btn" onClick={() => setAppliedFilterTypeId(filterTypeId)}>
            <FiFilter className="text-white" /> Apply Filter
          </button>
          <button
            className="btn btn-reset-filter filter-btn"
            onClick={() => {
              setFilterTypeId("");
              setAppliedFilterTypeId("");
            }}
          >
            <FiRotateCcw className="text-white" /> Reset Filter
          </button>
        </div>
      </div>

      <div className="bg-white w-full rounded-lg pagination-shadow my-5">
        <div className="overflow-x-auto">
          <table className="min-w-full table-auto bg-white rounded-lg  overflow-hidden">
            <thead>
              <tr className="brand-gradient text-white">
                <th className="table-th">Image</th>
                <th className="table-th">Type</th>
                <th className="table-th">Sub Type</th>
                <th className="table-th">Link</th>
                <th className="table-th">Actions</th>
              </tr>
            </thead>
            <tbody>
              {categoryData.length === 0 ? (
                <tr>
                  <td colSpan={5} className="text-center py-6 text-gray-500">
                    No data found
                  </td>
                </tr>
              ) : (
                categoryData.map((item, index) => (
                  <tr
                    key={item.id}
                    className={`${
                      index % 2 === 0 ? "bg-gray-50" : "bg-gray-100"
                    } hover:bg-gray-200 transition-colors duration-300`}
                  >
                    <td className="table-td">
                      <img
                        src={item.image}
                        alt="Category"
                        className="h-16 w-16 object-cover rounded shadow"
                      />
                    </td>
                    <td className="table-td max-w-[200px]">
                      {item.type?.name}
                    </td>
                    <td className="table-td">
                      {item.subType?.name}
                    </td>
                    <td className="table-td max-w-[200px] truncate">
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:underline"
                      >
                        {item.link}
                      </a>
                    </td>
                    <td className="table-td flex space-x-1">
                      {canUpdate && (
                        <button
                          className="btn btn-edit text-white"
                          onClick={() => openEditModal(item)}
                        >
                          <FiEdit2 className="text-white" /> Edit
                        </button>
                      )}
                      {canDelete && (
                        <button
                          className="btn btn-delete text-white"
                          onClick={() => handleDelete(item.id)}
                        >
                          <MdDelete className="text-white" /> Delete
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <HomeScreenEntryModal
        isOpen={isModalOpen}
        onClose={closeModal}
        editingItem={editingItem}
        types={types}
        getHomeScreenSubTypes={getHomeScreenSubTypes}
        onSubmit={handleSave}
      />
    </div>
  );
}

export default DataManagement;
